import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  INPUT_NAME: `${cleanedFilename(__filename)}-input-name`,
  INPUT_KEY: `${cleanedFilename(__filename)}-input-key`,
  DELETE_FIELD_BUTTON: `${cleanedFilename(__filename)}-delete-field-button`,
};
